import React from 'react';
import * as PropTypes from 'prop-types';

import Popup from '../../../../common/Popup';
import { AddDocumentForm } from '../AddDocumentForm';

export function AddDocumentPopup({
  opened,
  onClose,
  formatMessage,
  attachment,
  setAttachment,
  appointmentId,
  allowedDocumentCategories,
}) {
  const title = formatMessage({
    id: 'appointment.documents.addDocument.title',
  });

  return (
    <Popup
      strictClose
      opened={opened}
      onClose={onClose}
      title={title}
      mobileFullScreen={false}
    >
      <AddDocumentForm
        formatMessage={formatMessage}
        onClose={onClose}
        attachment={attachment}
        setAttachment={setAttachment}
        appointmentId={appointmentId}
        allowedDocumentCategories={allowedDocumentCategories}
      />
    </Popup>
  );
}

AddDocumentPopup.propTypes = {
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  formatMessage: PropTypes.func,
  attachment: PropTypes.object,
  setAttachment: PropTypes.func,
  appointmentId: PropTypes.number,
  allowedDocumentCategories: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/AddDocumentPopup/index.jsx